// ChatComponent.jsx
import React from 'react';
import call from "../../assets/images/messages/call.svg"
import camera from "../../assets/images/messages/camera.svg"
// import dubbleTick from "../../assets/images/messages/dubleTick.svg"
import link from "../../assets/images/messages/link.svg"
import mic from "../../assets/images/messages/mic.svg"
import smile from "../../assets/images/messages/smile.svg"
import threeDot from "../../assets/images/messages/threeDot.svg"
import video from "../../assets/images/messages/video.svg"
import img from '../../assets/images/img.svg';
import search from "../../assets/images/dashboard/body/Search.svg"


const Message = () => {
    const messages = [
        { id: 1, text: 'Hey There!', time: 'Today, 8:30pm', sender: 'other' },
        { id: 2, text: 'How are you?', time: 'Today, 8:30pm', sender: 'other' },
        { id: 3, text: 'Hello!', time: 'Today, 8:33pm', sender: 'me' },
        { id: 4, text: 'I am fine and how are you?', time: 'Today, 8:34pm', sender: 'me' },
        { id: 5, text: 'I am doing well. Can we meet tomorrow?', time: 'Today, 8:36pm', sender: 'other' },
        { id: 6, text: 'Yes Sure!', time: 'Today, 8:38pm', sender: 'me' },
    ];

    const users = [
        { id: 1, name: 'Lucas Fournier', image: img, accepted: true },
        { id: 2, name: 'Isabelle Fournier', image: img, accepted: false },
        { id: 3, name: 'Mathieu Fournier', image: img, accepted: true },
        { id: 4, name: 'Elise Fournie', image: img, accepted: false },
        { id: 5, name: 'Victoria H', image: img, accepted: false },
    ];

    return (
        <div className='flex md:flex-row flex-col p-[30px] bg_body '>
            <div>
                <div className='relative hidden lg:flex items-center mb-4'>
                    <input type="search" placeholder='Search' className='w-full h-8 border-2 rounded-lg pl-8' />
                    <img src={search} alt="search" className='absolute left-[10px] top-[10px] ' />
                </div>

                <div className="hidden md:block w-[264.68px] h-auto bg-[#F6F2EF] border-2 border_dark rounded-lg shadow-md p-[10.3px] ">
                    <div className="flex justify-between items-center mb-[5.45px]">
                        <span className=" font_family font-bold">Chats</span>
                    </div>

                    <ul className="">
                        {users.map((user) => (
                            <li key={user.id} className="flex justify-between items-center py-2 border-b font_ovo">
                                <div className='flex items-center'>
                                    <img
                                        src={user.image}
                                        alt={user.name}
                                        className="w-[31.px] h-[31.64px] rounded-full mr-4"
                                    />
                                    <div className='text-[9.8px] mr-[15.18px]'>
                                        <p className="text-xs pb-1">{user.name}</p>
                                        <span className='text-[10px]'>April fool’s day</span>
                                    </div>
                                </div>

                                <div className='text-[9.8px] mr-[15.18px] text-right'>
                                    <p className="text-[10px] pb-1 text-[#6EAB5E]">Today, 12.11pm</p>
                                    <span className='text-[10px] px-[6px] py-[2px] bg-[#FF4161] text-white rounded-full'>1</span>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className='block md:hidden relative items-center w-full mb-4'>
                <input type="search" placeholder='Search' className='w-full h-8 border-0 rounded-lg' />
                <img src={search} alt="search" className='absolute right-[15px] top-[10px] ' />
            </div>

            <div className="flex w-full md:ml-[30px] flex-col h-screen  md:mx-auto bg-[#F6F2EF] border-2 border_dark rounded-xl shadow-md ">
                <div className="flex justify-between items-center m-4 pb-4  border-b border-gray-200">
                    <div className="flex items-center space-x-3">
                        <img
                            src={img}
                            alt="User"
                            className="w-10 h-10 rounded-full"
                        />
                        <div>
                            <h3 className="text-sm font-semibold text-gray-900">Lucas Fournier</h3>
                            <p className="text-xs text-gray-500">Online • Last seen, 2:02pm</p>
                        </div>
                    </div>
                    <div className="flex space-x-4">
                        <button className="text-gray-600 text-lg"><img src={call} alt="call" /></button>
                        <button className="text-gray-600 text-lg"><img src={video} alt="video" /></button>
                        <button className="text-gray-600 text-lg"><img src={threeDot} alt="threeDot" /></button>
                    </div>
                </div>

                <div className="flex-1 overflow-y-auto p-4 bg-[#F6F2EF]  space-y-4">
                    {messages.map((msg) => (
                        <div
                            key={msg.id}
                            className={`flex ${msg.sender === 'me' ? 'justify-end' : 'justify-start'
                                }`}
                        >
                            <div
                                className={`max-w-[70%] px-4 py-2 rounded-lg text-sm relative`}
                            >
                                <p className={`px-4 py-1 ${msg.sender === 'me'
                                    ? 'bg-[#C6AFFF] text-white rounded-full'
                                    : 'bg-[#362269] text-white rounded-full border border-gray-200'
                                    }`}>
                                    {msg.text}
                                </p>

                                {msg.sender === 'me'
                                    ? <div className='p-1  right-0 w-fit rounded-full bg-[#C6AFFF] absolute'></div>
                                    : <div className='p-1 left-0 rounded-full bg-[#E7E7E7] absolute'></div>
                                }
                                <span className="text-xs text-gray-400 block mt-1">
                                    {msg.time}
                                </span>
                            </div>

                        </div>
                    ))}
                </div>

                <div className="flex items-center p-3 rounded-b-lg  bg-[#F6F2EF]">
                    <div className='flex w-full bg-white rounded-lg'>
                        <button className="mx-4 "><img src={link} alt="link" /></button>

                        <input
                            type="text"
                            placeholder="Type your message here..."
                            className="flex-1 px-4 py-2 bg-transparent border-0 outline-0 outline-none text-sm"
                        />
                        <button className="ml-4 "><img src={smile} alt="smile" /></button>
                        <button className="mx-4 "><img src={camera} alt="camera" /></button>
                    </div>
                    <button className="ml-4 bg-[#C6AFFF] p-2 px-3 rounded-lg"><img src={mic} alt="mic" /></button>
                </div>
            </div>
        </div>
    );
};

export default Message;
